import React from 'react';
import { Select } from 'antd';
import { useI18n } from '../i18n';

const { Option } = Select;

const flagSvg = {
  gb: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 42">
      <rect width="60" height="42" fill="#012169"/>
      <path d="M0 0L25 17.5H16.5L0 6V0zm60 0v6L43.5 17.5H35L60 0zM60 42L35 24.5h8.5L60 36v6zM0 42v-6l16.5-11.5H25L0 42z" fill="#fff"/>
      <path d="M0 0l20 14h-4.5L0 3.2V0zm60 0v3.2L44.5 14H40L60 0zM60 42L40 28h4.5L60 38.8V42zM0 42v-3.2L15.5 28H20L0 42z" fill="#C8102E"/>
      <path d="M24 0h12v42H24zM0 15h60v12H0z" fill="#fff"/>
      <path d="M26.5 0h7v42h-7zM0 17.5h60v7H0z" fill="#C8102E"/>
    </svg>
  `,
  dk: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 42">
      <rect width="60" height="42" fill="#C60C30"/>
      <rect x="18" width="8" height="42" fill="#fff"/>
      <rect y="17" width="60" height="8" fill="#fff"/>
    </svg>
  `,
};

function FlagIcon({ country }) {
  const commonStyle = {
    width: 20,
    height: 14,
    borderRadius: 3,
    overflow: 'hidden',
    border: '1px solid #d9d9d9',
    display: 'inline-block',
    flexShrink: 0,
    boxShadow: 'inset 0 0 0 0.5px rgba(0,0,0,0.04)',
    background: '#fff',
  };

  return (
    <span style={commonStyle}>
      <img
        src={`data:image/svg+xml;utf8,${encodeURIComponent(flagSvg[country])}`}
        alt=""
        aria-hidden="true"
        style={{ width: '100%', height: '100%', display: 'block' }}
      />
    </span>
  );
}

function LanguageOptionLabel({ country, children }) {
  return (
    <span
      className="language-option-label"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <FlagIcon country={country} />
      <span className="language-option-text">
        {children}
      </span>
    </span>
  );
}

export default function LanguageSelect({ value, onChange, width = 150 }) {
  const { t } = useI18n();

  return (
    <Select
      value={value}
      onChange={onChange}
      className="language-select"
      style={{ width }}
      popupClassName="language-select-dropdown"
      optionLabelProp="label"
    >
      <Option
        value="en"
        label={<LanguageOptionLabel country="gb">{t('English')}</LanguageOptionLabel>}
      >
        <LanguageOptionLabel country="gb">{t('English')}</LanguageOptionLabel>
      </Option>
      <Option
        value="da"
        label={<LanguageOptionLabel country="dk">{t('Danish')}</LanguageOptionLabel>}
      >
        <LanguageOptionLabel country="dk">{t('Danish')}</LanguageOptionLabel>
      </Option>
    </Select>
  );
}
